module.exports = __webpack_public_path__ + "img/cloth_g3_item-15.016b9593.svg";